export const PortfolioCustomTradeTicketListQuery = /* GraphQL */ `
  query CustomListTradeTickets($accountId: ID = "", $limit: Int = 1000000) {
    listTradeTickets(filter: { accountId: { eq: $accountId } }, limit: $limit) {
      items {
        accountId
        accruedDays
        accruedInterest
        amount
        bondPrice
        createdAt
        id
        finalCommissionAmount
        isClosed
        loadedYield
        updatedAt
        tradeDate
        orderTicketId
        settlementDate
        orderTicket {
          id
          accountId
          balanceAccountId
          bondId
          faceAmount
          bondPrice
          minimumFillSize
          direction
          status
          isConfirmed
          confirmedAt
          isImmediate
          createdAt
          expiresAt
          closingTradeTicketId
          appliedCommissionRate {
            amount
            rate
          }
        }
      }
    }
  }
`;
